import "core-js/modules/es.array.push.js";
import { markRaw } from "vue";
import { ShoppingCart, ChatDotSquare } from "@element-plus/icons-vue";
import { default_max_width } from "@/globalcfg.js";
import { post_Json_elk_statistic } from "@/jsUtils/nodejsRequest";
export default {
  components: {
    ShoppingCart,
    ChatDotSquare
  },
  props: {
    appName: {
      type: String,
      required: true
    },
    showFeedback: {
      Type: Boolean,
      default: true
    },
    showShopping: {
      Type: Boolean,
      default: true
    },
    shopUrl: {
      type: String
    }
  },
  methods: {
    //点击反馈按钮
    handleFeedback() {
      this.$router.push({
        path: 'feedback',
        query: {
          appName: this.appName
        }
      });
    },
    //点击购物车
    handleShopping() {
      window.location.href = this.shopUrl;
      this.sendElk_Stat_gotoAmazon(this.appName);
    },
    // 统计日志
    sendElk_Stat_gotoAmazon(product) {
      let data = {
        "event": "product_goto_amazon",
        "data": {
          "product_from_path": "product_detail",
          "product_type": product
        }
      };
      post_Json_elk_statistic(data);
    }
  },
  computed: {
    //获取当前的最大宽度
    getIconSize() {
      if (window.innerWidth >= default_max_width - 100) {
        // "min(max(7vw, 7vh), window.innerWidth * 0.07)";
        let size = Math.min(Math.max(0.07 * window.innerWidth, 0.07 * window.innerHeight), default_max_width * 0.07);
        return size;
      } else {
        // "min(max(5vw, 5vh), default_max_width * 0.05)";
        let size = Math.min(Math.max(0.05 * window.innerWidth, 0.05 * window.innerHeight), default_max_width * 0.05);
        return size;
      }
    }
  }
};